import * as React from "react";
import { Text } from "react-native-paper";
import routes from "../../routing/routes";
import AboutColorsBox from "../../containers/AboutColorsBox";
import blueParrot from "../../containers/AboutColors/blueParrot.png";
import greenParrot from "../../containers/AboutColors/greenParrot.png";
import yellowParrot from "../../containers/AboutColors/yellowParrot.png";
import redParrot from "../../containers/AboutColors/redParrot.png";
import t from "../../translations";

export default (props) => {
  const onClick = (route) => () => props.navigation.navigate(route);

  return (
    <>
      <AboutColorsBox
        source={redParrot}
        onPress={onClick(routes.RedAboutColorsPage)}
      >
        <Text>{t('red_title_AboutColorsBox')}</Text>
      </AboutColorsBox>
      <AboutColorsBox
        source={yellowParrot}
        onPress={onClick(routes.YellowAboutColorsPage)}
      >
        <Text>{t('yellow_title_AboutColorsBox')}</Text>
      </AboutColorsBox>
      <AboutColorsBox
        source={blueParrot}
        onPress={onClick(routes.BlueAboutColorsPage)}
      >
        <Text>{t('blue_title_AboutColorsBox')}</Text>
      </AboutColorsBox>
      <AboutColorsBox
        source={greenParrot}
        onPress={onClick(routes.GreenAboutColorsPage)}
      >
        <Text>{t('green_title_AboutColorsBox')}</Text>
      </AboutColorsBox>
    </>
  );
};
